// Log aktivitas: fungsi tampilan murni (teks masa simpan, label, ringkasan perubahan, CSV). Dipakai componen/log/LogAktivitas.jsx.

export const LABEL_KATEGORI = {
  auth: 'Login', transaksi: 'Transaksi', piutang: 'Piutang', shift: 'Shift & kas', stok: 'Stok', pembelian: 'Pembelian',
  produk: 'Produk', promo: 'Promo', pengguna: 'Pengguna', pengaturan: 'Pengaturan', keuangan: 'Keuangan', absensi: 'Absensi',
  dapur: 'Dapur', pendukung: 'Data pendukung', laporan: 'Ekspor', akses: 'Akses halaman', cetak: 'Cetak', reservasi: 'Reservasi', log: 'Log',
};
export const LABEL_PERAN = { superadmin: 'Superadmin', admin: 'Admin cabang', kasir: 'Kasir', karyawan: 'Karyawan', dapur: 'Dapur', pelanggan: 'Pelanggan', sistem: 'Sistem' };

export const labelKategori = (k) => LABEL_KATEGORI[k] || k || '-';
export const labelPeran = (r) => LABEL_PERAN[r] || r || '-';

const BULAN = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];
const dua = (n) => String(n).padStart(2, '0');

/** "21 Okt 2026" */
export const tanggalPendek = (nilai) => {
  const d = new Date(nilai);
  return Number.isNaN(d.getTime()) ? '-' : `${d.getDate()} ${BULAN[d.getMonth()]} ${d.getFullYear()}`;
};
/** "21 Okt 2026 10.32" */
export const waktuLog = (nilai) => {
  const d = new Date(nilai);
  return Number.isNaN(d.getTime()) ? '-' : `${tanggalPendek(d)} ${dua(d.getHours())}.${dua(d.getMinutes())}`;
};

/**
 * Keterangan masa simpan untuk banner. Contoh: "Log disimpan 365 hari. Log tertua (3 Nov 2025) akan dihapus otomatis 3 Nov 2026, 13 hari lagi."
 * `tingkat`: 'info' biasa, 'warning' bila tinggal <= 30 hari (ada log yang sebentar lagi terhapus: waktunya mengekspor).
 */
export const NAMA_BULAN = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];

/** "1 tahun", "3 bulan" untuk masa simpan yang bulat; selain itu '' (cukup jumlah harinya). */
export const teksDurasi = (hari) => {
  if (hari % 365 === 0) return `${hari / 365} tahun`;
  if (hari % 30 === 0) return `${hari / 30} bulan`;
  return '';
};

export const hariDalamBulan = (bulan, tahun = 2024) => new Date(tahun, bulan, 0).getDate();
const kejadianTahunan = (tahun, bulan, tanggal) => new Date(tahun, bulan - 1, Math.min(tanggal, hariDalamBulan(bulan, tahun)));
/** Log SEBELUM tanggal ini dihapus bila memilih hapus tahunan: tanggal-bulan itu pada tahun lalu (dari kejadian terakhir). Sama dengan server. */
export const batasHapusTahunan = (bulan, tanggal, sekarang = new Date()) => {
  let k = kejadianTahunan(sekarang.getFullYear(), bulan, tanggal);
  if (k > sekarang) k = kejadianTahunan(sekarang.getFullYear() - 1, bulan, tanggal);
  return kejadianTahunan(k.getFullYear() - 1, bulan, tanggal);
};
/** Log sebelum tanggal ini dihapus bila memilih masa simpan bergulir [hari] hari. */
export const batasHapusHari = (hari, sekarang = new Date()) => { const d = new Date(sekarang); d.setHours(0, 0, 0, 0); d.setDate(d.getDate() - hari); return d; };

export const infoRetensi = (retensi) => {
  const hari = retensi?.hariSimpan || 365;
  const durasi = teksDurasi(hari);
  const t = retensi?.mode === 'tahunan' ? retensi.tahunan : null;
  const dasar = t
    ? `Log dihapus otomatis setiap ${t.tanggal} ${NAMA_BULAN[t.bulan - 1]}: log sebelum ${t.tanggal} ${NAMA_BULAN[t.bulan - 1]} tahun lalu.`
    : `Log disimpan ${hari} hari${durasi ? ` (${durasi})` : ''}, lalu dihapus otomatis.`;
  if (!retensi?.tertua || retensi.sisaHari === null || retensi.sisaHari === undefined) return { teks: dasar, tingkat: 'info' };
  const sisa = retensi.sisaHari;
  const kapan = sisa <= 0 ? 'hari ini' : sisa === 1 ? 'besok' : `${sisa} hari lagi`;
  return {
    teks: `${dasar} Log tertua (${tanggalPendek(retensi.tertua)}) akan dihapus pada ${tanggalPendek(retensi.hapusPada)}, ${kapan}.`,
    tingkat: sisa <= 30 ? 'warning' : 'info',
    sisa,
  };
};

/** Penanda per baris bila tinggal <= 30 hari sebelum terhapus, mis. "dihapus 12 hari lagi". */
export const penandaHapus = (dihapusDalamHari) => {
  if (dihapusDalamHari === null || dihapusDalamHari === undefined || dihapusDalamHari > 30) return null;
  if (dihapusDalamHari <= 0) return 'dihapus hari ini';
  if (dihapusDalamHari === 1) return 'dihapus besok';
  return `dihapus ${dihapusDalamHari} hari lagi`;
};

const NAMA_KOLOM = {
  nama: 'Nama', namabarang: 'Nama', harga: 'Harga', harga_modal: 'Harga modal', kodebarang: 'Kode barang', stok: 'Stok', hariSimpan: 'Masa simpan (hari)', hapusTahunan: 'Hapus tahunan', hargaGrosir: 'Harga grosir',
  nilai: 'Nilai', jenis: 'Jenis', aktif: 'Aktif', sasaran: 'Sasaran', username: 'Username', role: 'Peran', cabanguuid: 'Cabang',
  totaljual: 'Total', status_pembayaran: 'Status bayar', status_order: 'Status pesanan', pembayaran: 'Metode', namaCustomer: 'Pelanggan',
  namacabang: 'Nama cabang', alamat: 'Alamat', zona_waktu: 'Zona waktu', radius: 'Radius', tipe_cabang: 'Tipe cabang', jumlah: 'Jumlah',
};
const UANG = new Set(['harga', 'harga_modal', 'totaljual', 'jumlah', 'nilai']);
const nilaiTampil = (k, v) => {
  if (v === null || v === undefined || v === '') return '(kosong)';
  if (typeof v === 'boolean') return v ? 'ya' : 'tidak';
  if (UANG.has(k) && Number.isFinite(Number(v)) && String(v).trim() !== '') return Number(v).toLocaleString('id-ID');
  const t = typeof v === 'object' ? JSON.stringify(v) : String(v);
  return t.length > 80 ? `${t.slice(0, 77)}...` : t;
};

/** [{ kolom: 'Harga', lama: '100.000', baru: '105.000' }] dari nilai sebelum/sesudah (hanya kolom yang berubah). */
export const barisPerubahan = (sebelum, sesudah) => {
  const lama = sebelum && typeof sebelum === 'object' ? sebelum : null;
  const baru = sesudah && typeof sesudah === 'object' ? sesudah : null;
  const kunci = [...new Set([...Object.keys(lama || {}), ...Object.keys(baru || {})])].filter((k) => k !== 'cabanguuid' || (lama && baru));
  return kunci.map((k) => ({
    kolom: NAMA_KOLOM[k] || k,
    lama: lama && k in lama ? nilaiTampil(k, lama[k]) : null,
    baru: baru && k in baru ? nilaiTampil(k, baru[k]) : null,
  }));
};

const sel = (v) => {
  const t = v === null || v === undefined ? '' : String(v);
  return /[",\n;]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t;
};

/** CSV (dibuka Excel) dari baris log. IP hanya bila `lihatIp` (superadmin). */
export const buatCsv = (baris, { lihatIp = false, tampilkanCabang = false } = {}) => {
  const kepala = ['Waktu', ...(tampilkanCabang ? ['Cabang'] : []), 'Pengguna', 'Peran', 'Tingkat', 'Kategori', 'Aktivitas', 'Objek', 'Perubahan', 'Lokasi', ...(lihatIp ? ['IP'] : []), 'Perangkat'];
  const isi = baris.map((r) => {
    const perubahan = barisPerubahan(r.sebelum, r.sesudah).filter((b) => b.kolom !== 'Cabang')
      .map((b) => `${b.kolom}: ${b.lama ?? '-'} -> ${b.baru ?? '-'}`).join(' | ');
    return [
      waktuLog(r.waktu), ...(tampilkanCabang ? [r.cabang || ''] : []), r.pengguna?.nama || r.pengguna?.username || '', labelPeran(r.pengguna?.role),
      r.tingkat === 'penting' ? 'Penting' : 'Biasa', labelKategori(r.kategori), r.ringkasan, r.target || '', perubahan, r.lokasi || '',
      ...(lihatIp ? [r.ip || ''] : []), r.perangkat || '',
    ].map(sel).join(';');
  });
  return `﻿${[kepala.join(';'), ...isi].join('\r\n')}`; // BOM + titik koma: terbaca benar di Excel Indonesia
};
